export const REQUEST_COWS_PAGE_INFORMATION = 'REQUEST_COWS_PAGE_INFORMATION';
export const COWS_PAGE_INFORMATION_ERROR = 'COWS_PAGE_INFORMATION_ERROR';
export const COWS_PAGE_INFORMATION_SUCCESS = 'COWS_PAGE_INFORMATION_SUCCESS';
export const SAVE_CHANGES_TO_COWS_PAGE = 'SAVE_CHANGES_TO_COWS_PAGE';
export const SAVE_CHANGES_TO_COWS_PAGE_SUCCESS =
  'SAVE_CHANGES_TO_COWS_PAGE_SUCCESS';
export const SAVE_CHANGES_TO_COWS_PAGE_ERROR =
  'SAVE_CHANGES_TO_COWS_PAGE_ERROR';
